var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L14 0L14 14L0 14L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usuario-(8)-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L14 0L14 14L0 14L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.90036 6.74384C7.82684 6.74384 8.6291 6.41155 9.28461 5.75594C9.94011 5.10044 10.2724 4.2984 10.2724 3.37181C10.2724 2.44555 9.94011 1.6434 9.2845 0.987682C8.62889 0.332289 7.82674 0 6.90036 0C5.97377 0 5.17172 0.332289 4.51622 0.987789C3.86072 1.64329 3.52832 2.44544 3.52832 3.37181C3.52832 4.2984 3.86072 5.10055 4.51633 5.75605C5.17194 6.41144 5.97409 6.74384 6.90036 6.74384L6.90036 6.74384Z",
    id: "Shape",
    fill: "#848484",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8004 10.7645C12.7815 10.4917 12.7433 10.1941 12.687 9.87985C12.6301 9.56327 12.557 9.26398 12.4694 8.99044C12.3789 8.70771 12.2559 8.4285 12.1038 8.16094C11.9459 7.88323 11.7605 7.64141 11.5524 7.44243C11.3348 7.23425 11.0685 7.06688 10.7604 6.94479C10.4534 6.82335 10.1132 6.76183 9.74933 6.76183C9.60641 6.76183 9.4682 6.82046 9.20128 6.99425C9.037 7.10138 8.84485 7.22528 8.63037 7.36232C8.44698 7.47917 8.19853 7.58865 7.89166 7.68777C7.59227 7.78465 7.28828 7.83378 6.98825 7.83378C6.68822 7.83378 6.38434 7.78465 6.08463 7.68777C5.77808 7.58876 5.52963 7.47928 5.34645 7.36242C5.134 7.22667 4.94174 7.10277 4.77501 6.99414C4.50841 6.82036 4.37009 6.76172 4.22717 6.76172C3.86316 6.76172 3.52307 6.82335 3.2162 6.9449C2.90837 7.06677 2.64188 7.23414 2.42409 7.44253C2.21613 7.64163 2.03059 7.88334 1.87294 8.16094C1.72095 8.4285 1.5979 8.7076 1.50732 8.99055C1.41985 9.26409 1.34668 9.56327 1.28986 9.87985C1.23357 10.1937 1.19533 10.4913 1.17642 10.7648C1.15784 11.0327 1.14844 11.3107 1.14844 11.5915C1.14844 12.3223 1.38075 12.9139 1.83887 13.3503C2.29132 13.7808 2.89 13.9992 3.61803 13.9992L10.3591 13.9992C11.0871 13.9992 11.6856 13.7809 12.1382 13.3503C12.5964 12.9143 12.8287 12.3225 12.8287 11.5914C12.8286 11.3093 12.8191 11.0311 12.8004 10.7645L12.8004 10.7645Z",
    id: "Shape",
    fill: "#848484",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayUser);
export default __webpack_public_path__ + "static/media/grayUser.fe94fe90c82fac4dd5c796db82887b56.svg";
export { ForwardRef as ReactComponent };